import { createFileRoute } from '@tanstack/react-router';
import { activeConfig } from '@/config';
import ErrorPage from '@/components/pages/error';

export const Route = createFileRoute('/error')({
  head: () => ({
    meta: [{ title: `Error | ${activeConfig.branding.appName}` }],
  }),
  component: ErrorPage,
});
